/**
 * @generated SignedSource<<c97fa8dd9e6fafbc86c40592e67f358d>>
 * @relayHash c7f7b9541d0181794ecb91653cfa9f78
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b2bbc37e70f750dd305329bdec2a7362a1fec1480f2f7aaba45d03323685ba34

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type proposalsSettingsPageQuery$variables = {
  accountSlug: string;
  branchName: string;
  graphSlug: string;
};
export type proposalsSettingsPageQuery$data = {
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"configuredReviewersOptionsFragment">;
  };
  readonly branch: {
    readonly id: string;
    readonly schemaProposalsConfiguration: {
      readonly " $fragmentSpreads": FragmentRefs<"configuredReviewersCurrentFragment" | "proposalsSettingsPageEnforceChecksFragment" | "proposalsSettingsPageKeepApprovalsOnEditFragment">;
    };
  };
};
export type proposalsSettingsPageQuery = {
  response: proposalsSettingsPageQuery$data;
  variables: proposalsSettingsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branchName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "graphSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "accountSlug"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "accountSlug",
    "variableName": "accountSlug"
  },
  {
    "kind": "Variable",
    "name": "graphSlug",
    "variableName": "graphSlug"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "branchName"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  (v5/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "proposalsSettingsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": "account",
          "args": (v3/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "configuredReviewersOptionsFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*: any*/),
          "concreteType": "Branch",
          "kind": "LinkedField",
          "name": "branch",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": "SchemaProposalsConfiguration",
                "kind": "LinkedField",
                "name": "schemaProposalsConfiguration",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "proposalsSettingsPageEnforceChecksFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "configuredReviewersCurrentFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "proposalsSettingsPageKeepApprovalsOnEditFragment"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "proposalsSettingsPageQuery",
    "selections": [
      {
        "alias": "account",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Branch",
        "kind": "LinkedField",
        "name": "branch",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SchemaProposalsConfiguration",
            "kind": "LinkedField",
            "name": "schemaProposalsConfiguration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enforceChecks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "configuredReviewers",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v8/*: any*/)
                    ],
                    "type": "SchemaProposalsConfiguredReviewerUser",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "SchemaProposalsConfiguredReviewerTeam",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "keepApprovalsOnEdit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7f7b9541d0181794ecb91653cfa9f78",
    "id": "b2bbc37e70f750dd305329bdec2a7362a1fec1480f2f7aaba45d03323685ba34",
    "metadata": {},
    "name": "proposalsSettingsPageQuery",
    "operationKind": "query",
    "text": "query proposalsSettingsPageQuery(\n  $accountSlug: String!\n  $graphSlug: String!\n  $branchName: String!\n) {\n  account: accountBySlug(slug: $accountSlug) {\n    __typename\n    ...configuredReviewersOptionsFragment\n    id\n  }\n  branch(accountSlug: $accountSlug, graphSlug: $graphSlug, name: $branchName) {\n    id\n    schemaProposalsConfiguration {\n      ...proposalsSettingsPageEnforceChecksFragment\n      ...configuredReviewersCurrentFragment\n      ...proposalsSettingsPageKeepApprovalsOnEditFragment\n    }\n  }\n}\n\nfragment configuredReviewersCurrentFragment on SchemaProposalsConfiguration {\n  configuredReviewers {\n    __typename\n    ... on SchemaProposalsConfiguredReviewerUser {\n      id\n      __typename\n      user {\n        id\n        name\n        avatarUrl\n      }\n    }\n    ... on SchemaProposalsConfiguredReviewerTeam {\n      id\n      __typename\n      team {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment configuredReviewersOptionsFragment on Organization {\n  members {\n    nodes {\n      user {\n        id\n        name\n        avatarUrl\n      }\n      id\n    }\n  }\n  teams {\n    nodes {\n      id\n      name\n    }\n  }\n}\n\nfragment proposalsSettingsPageEnforceChecksFragment on SchemaProposalsConfiguration {\n  enforceChecks\n}\n\nfragment proposalsSettingsPageKeepApprovalsOnEditFragment on SchemaProposalsConfiguration {\n  keepApprovalsOnEdit\n}\n"
  }
};
})();

(node as any).hash = "0def93e36a5fedf5ff6bede07e1a2fb7";

export default node;
